import JSZip from "jszip";
import saveAs from 'save-as'
import {saveSettings, loadSettings, removeSettings} from '../lib/local-storage';


const bundleAnnotation = (annotationsArray) => {
    let annotations = '';
    for(let index = 0; index < annotationsArray.length; index++){
        annotations += `${annotationsArray[index].label} ${annotationsArray[index].left} ${annotationsArray[index].top} ${annotationsArray[index].width} ${annotationsArray[index].height}`;
        if(index < annotationsArray.length) annotations += "\n";
    }
    return annotations;
}
const createZip = async(resExtents) => {
    let settings = {...loadSettings()};
    return new Promise(async (resolve, reject) => {
        var zip = new JSZip();
        for(let index = 0; index < resExtents.length; index++){
            const blob = await new Promise(resolve => resExtents[index].canvas.toBlob(resolve, 'image/jpeg', 0.95));

            zip.folder("images").file(`image${settings.downloadCount}.jpg`, blob, {binary: true});
            const annotation = bundleAnnotation(resExtents[index].annotation);
            zip.folder("labels").file(`image${settings.downloadCount}.txt`, annotation);
            settings.downloadCount++;
        }
        
        zip.generateAsync({type:"blob"}).then(function (blob) { 
            saveAs(blob, "image.zip");
            saveSettings(settings)
            resolve();
        }, function (err) {
            reject(err);
        });
    
})}

export default createZip;